import { webApiGet, webApiPost, webApiPut } from './request';

// export const loginApi = (request) => webApiPost('/login', { ...request })

// qlib
export const getcategoriesApi = () => webApiGet(`/category/getcategories`);
export const getQuestionsApi = (payload) => webApiPost('/question/getquestions', [...payload]);
export const loginApi = (request) => webApiPost('/user/login', { ...request });
export const getUserInfoApi = () => webApiGet(`/user/roles`);
export const getYearsApi = () => webApiGet(`/questionnaire/getQuestionnaireYears`);
// export const questionnaireNamesApi = (payload) =>
//   webApiGet(`/questionnaire/getQuestionnaireNames${payload && '?year=' + payload?.year, '?client=' + payload?.client}`);
export const questionnaireNamesApi = (payload) => {
  let query = '';

  if (payload?.year || payload?.client) {
    query = `?${payload.year ? `year=${payload.year}` : ''}${
      payload.year && payload.client ? '&' : ''
    }${payload.client ? `client=${payload.client}` : ''}`;
  }

  return webApiGet(`/questionnaire/getQuestionnaireNames${query}`);
};
export const getQuestionsByIdApi = (payload) =>
  webApiPost(`/question/getQuestionsByQuestionnaireId?id=${payload}`);
export const updateProfileApi = (payload) => webApiPut(`/user/updateprofile`, { ...payload });
export const updatePasswordApi = (payload) => webApiPut(`/user/updatepassword`, { ...payload });

export const getSurveyQues = (id) => webApiGet(`/questionnaire/getSurveyQuestions?id=${id}`);
export const getSurveyFilter = (id) => webApiGet(`/questionnaire/getSurveyFilters?id=${id}`);
export const getSurveyChartData = (request) =>
  webApiPost(`/questionnaire/${request.cqId != '' ? 'CrossTab' : 'getSurveyChartData'}`, {
    ...request
  });
export const getUserProfile = (id) => webApiGet(`/user/getprofile?username=${id}`);
export const updatequestionnaireNamesApi = (payload) =>
  webApiPost(`/questionnaire/UpdateQuestionnaire`, { ...payload });
export const importDataApi = ({ file, title, year, id }) =>
  webApiPost(
    `/import/ImportData?${id && 'Id=' + id}${title && '&Title=' + title + '&'}${
      year && 'Year=' + year
    }`,
    file
  );
export const searchQuestionnaire = (id) => webApiGet(`/questionnaire/Search?searchString=${id}`);

export const getExcelDownloadData = (request) =>
  webApiPost('/questionnaire/Download/Excel', { ...request });

export const getCrossTabQuestions = (id) =>
  webApiGet(`/questionnaire/getCrossTabQuestions?id=${id}`);

export const clientNamesApi = (payload) =>
  webApiGet(`/questionnaire/getClients${payload ? '?year=' + payload : ''}`);

export const downloadImportFileApi =(payload)=>
  webApiGet(`/import/download-importfile?QuestionnaireId=${payload}`);

// Title=${title}&
